// ap-site
// 
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { MorphSVGPlugin } from "gsap/MorphSVGPlugin";

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger, MorphSVGPlugin);
let js_ap_site = document.querySelector(".js-ap-site");

function getTanDeg(deg) {
  var rad = deg * Math.PI/180;
  return Math.tan(rad);
}

let isResized = 0;

export function initApSite(isResized) {
    gsap.registerPlugin(ScrollToPlugin, ScrollTrigger, MorphSVGPlugin);
    
    if (js_ap_site !== null) {            
        let height = js_ap_site.clientHeight;
        let width = js_ap_site.clientWidth;
        //console.log('.js-ap-site: w x h: ' + width + ' x ' + height);
        
        let js_ap_site__svg = document.getElementById("apSiteSvg");
        
        let js_ap_site__ap = document.querySelector('.js-ap-site__ap');
        let compStylesAp = window.getComputedStyle(js_ap_site__ap);
        let apHeight = js_ap_site__ap.clientHeight;
        let paddingLeft = parseInt(compStylesAp.paddingLeft);
        //console.log('paddingLeft: ' + paddingLeft);
        //console.log('apHeight: ' + apHeight);
        let js_ap_site__img = document.querySelector('.c-ap__div');
        let compStylesApImg = window.getComputedStyle(js_ap_site__img);
        let apImgHeight = js_ap_site__img.clientHeight;
        let apImgWidth = js_ap_site__img.clientWidth;
        //console.log('compStylesApImg.marginRight: ' + parseInt(compStylesApImg.marginRight));
        //console.log('apImgWidth: ' + apImgWidth);
        //console.log('js_ap_site__ap.childElementCount: ' + js_ap_site__ap.childElementCount);
        //console.log('apImgHeight: ' + apImgHeight);
        
        let ap_site__content = document.querySelector('.c-ap-site__content');
        let apContentHeight = ap_site__content.clientHeight;
        let apContentWidth = ap_site__content.clientWidth;
        
        let apSiteLabelWrapper = document.querySelector('.js-ap-site__label-wrapper');
        if (js_ap_site__ap.childElementCount === 1) {
            apSiteLabelWrapper.style.left = (paddingLeft + (1.75 * apImgWidth) + (1.75 * parseInt(compStylesApImg.marginRight))) + 'px';
        } else {
            apSiteLabelWrapper.style.left = (paddingLeft + (js_ap_site__ap.childElementCount * apImgWidth) + (js_ap_site__ap.childElementCount * parseInt(compStylesApImg.marginRight))) + 'px';
            
        }
        
        /*svg zeichnen
        -------------- */
        // viewbox
        js_ap_site__svg.setAttribute('viewBox', '0 0 ' + width + ' ' + height);        
        
        // point 2
        // A = 0,0; alpha = 90°; beta = 29°; c = apImgHeight; b = c/tan(beta)
        // x = point2_x
        // y = 0
        let point2_x = parseInt(apImgHeight/getTanDeg(29));
        let roofApSitePoint2 = point2_x + ',0';
        let point2_x_opened = (apContentWidth - parseInt(apHeight/getTanDeg(36)));
        let roofApSitePoint2_opened = point2_x_opened + ',0';
        
        // point 1
        // A = ?,height; alpha = 90°; beta = 36°; b = height; c = b/tan(beta)
        // x = c + point2_x
        // y = height
        let roofApSitePoint1 = (parseInt(height/getTanDeg(36)) + point2_x) + ',' + height;
        let roofApSitePoint1_opened = (parseInt(apContentHeight/getTanDeg(36)) + apContentWidth) + ',' + height;
        
        // point 3
        let roofApSitePoint3 = '0,' + parseFloat(apImgHeight);
        
        //point 4
        let roofApSitePoint4 = '0,' + height;
        
        let pointsRoofApSiteClosed = roofApSitePoint1 + ' ' + roofApSitePoint2 + ' ' + roofApSitePoint3 + ' ' + roofApSitePoint4;
        let d = document.getElementById('roofApSite');
        d.setAttribute("points", pointsRoofApSiteClosed);
        
        let classes = js_ap_site.classList;
        
        let isActive = false;
        let isOpen = false;
        
        let setActive = 0;
        let setOpen = 0;

        //console.log(pointsRoofApSiteClosed);
        
        // -----------------------------------------------------------------------------
        // gsap
        // -----------------------------------------------------------------------------
        let apSiteActivate = gsap.to('.js-ap-site', {
          duration: 1,
          y: `-${apHeight}`,
          ease: "power4.inOut",
          paused: true
        });

        let apSiteOpen = gsap.to('.js-ap-site', {
          duration: .5,
          y: `-${height}`,
          ease: "power4.inOut",
          paused: true
        });

        let apSiteClose = gsap.to('.js-ap-site', {
          duration: 1,
          y: height,
          ease: "power4.inOut",
          paused: true
        });
        
        let roofClose = gsap.to('#roofApSite', {
            duration: 1, 
            morphSVG: pointsRoofApSiteClosed,
            paused: true
        });
        
        let roofOpen = gsap.to('#roofApSite', {
            duration: .5, 
            morphSVG: roofApSitePoint1_opened + ' ' + roofApSitePoint2_opened + ' 0,' + (parseFloat(apImgHeight)/1.25) + ' ' + roofApSitePoint4,
            paused: true
        });
        let apLabelActivate = gsap.to('.js-ap-site__label-wrapper', {
          duration: 1,
          y: `-2.5rem`,
          ease: "power1.inOut",
          paused: true
        });
        
        let apLabelOpened = gsap.to('.js-ap-site__label-wrapper', {
          duration: .25,
          y: height,
          ease: "power1.inOut",
          paused: true
        });
        

        function animateFrom() {
            if (!isActive) { 
                if (setActive === true) { 
                    //console.log('!isActive, !isOpen, setActive = ' + setActive)
                    apSiteActivate.restart();
                    apLabelActivate.restart();
                    isActive = true;
                }
                
            } else {//isActive === true
                if (setActive === false) {
                    if (isOpen) {
                        //console.log('isActive, isOpen, setActive = ' + setActive)
                        //apSiteOpen.reverse().restart();
                        roofOpen.reverse();
                        apSiteClose.restart();
                        
                    } else {
                        apSiteActivate.reverse();
                        apLabelActivate.reverse();
                    }
                        
                    isActive = false;
                    isOpen = false;
                        
                } else {
                    if (!isOpen) {
                        if (setOpen === true) {
                            apSiteOpen.restart();
                            roofOpen.play();
                            apLabelOpened.restart();
                            isOpen = true;

                        } else if (setActive === false) { 
                            d.setAttribute('points', pointsRoofApSiteClosed);
                            isActive = false;
                        }
                        
                    } else {//isOpen == true
                        if (setActive === false) { 
                            apSiteOpen.reverse();
                            roofClose.reverse();
                            apLabelOpened.reverse();
                            isActive = false;
                        } else {
                            apSiteOpen.reverse();
                            roofOpen.reverse();
                            apLabelOpened.reverse();
                        }
                        isOpen = false;
                    }
                } 
            }
              
            //console.log('isActive: ' + isActive);
            //console.log('isOpen: ' + isOpen);
        }

        ScrollTrigger.create({
          id: 'ap-service',
          trigger: "#intro ~ article",//erste article nach intro
          start: "top bottom",
          endTrigger: "#adresse",
          end: "50% bottom",
          //endTrigger: "#site-footer",
          //end: "top bottom",
          markers: false,
          invalidateOnRefresh: true,
          //events: onEnter onLeave onEnterBack onLeaveBack
          onEnter: function() {
              setActive = true;
              setOpen = false;
              animateFrom();
          }, 
          onEnterBack: function() {
              setActive = true;
              setOpen = false;
              animateFrom();
          },
          onLeave: function() {
              setActive = false;
              setOpen = false;
              animateFrom();
          },
          onLeaveBack: function() {
              setActive = false;
              setOpen = false;
              animateFrom();
          }
        });
        //ScrollTrigger.addEventListener("refresh", () => ScrollTrigger.refresh());
        
        //if (isResized === 1) {
            //roofClose.invalidate();
            //roofOpen.invalidate();
            //ScrollTrigger.refresh(true);
            //console.log('scrollTrigger refreshed');
        //}
        
        js_ap_site.addEventListener('click', function (event) {          
          setActive = true;
          setOpen = (isOpen === true)? false : true;
          animateFrom();
        });
    }
}
